import { useEffect, useState } from "react";
import Onglet from "../../components/Onglet";
import Paging from "../../components/Paging";
import "./style.css"

function Works({ type }) {
    const [page, setPage] = useState(-1);
    const [works, setWorks] = useState([]);

    useEffect(() => {
        localStorage.setItem('opt_return_work', type === 1 ? 'mangas' : 'works');

        const fetchWorks = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/works/get/all`);
            const res = await req.json();

            if (req.status !== 200) {
                alert(res.message);
                return
            };

            const resFiltered = res.filter(e => e.type === type);
            const response = resFiltered.sort((a, b) => a.order - b.order);

            const chunkedData = [];
            const chunkSize = 5;

            for (let i = 0; i < response.length; i += chunkSize) {
                const chunk = response.slice(i, i + chunkSize);
                chunkedData.push(chunk);
            }

            const lastPaging = parseInt(sessionStorage.getItem('paging_works')) || 0;
            const validPage = Math.min(lastPaging, chunkedData.length - 1);

            setPage(validPage >= 0 ? validPage : 0);
            setWorks(chunkedData);
        }
        fetchWorks();
    }, [type]);

    useEffect(() => {
        if (page !== -1) sessionStorage.setItem('paging_works', page);
    }, [page]);

    const seriePath = (work) => {
        const page_path = work.type === 1 ? 'mangas' : 'works';
        return `/${page_path}/${work.title_path}`;
    }

    return (
        <div className='page page_works'>
            <p className="title_page">
                - <span>{type === 1 ? 'Mangas/Webcomics' : 'Other Works'}</span> -
            </p>

            {works && works[page] &&
                <section className="sect_works">
                    <ul className="works_list">
                        {works[page].map(work => (
                            <Onglet key={work.title_path} serie={work} to={seriePath(work)} line={true} />
                        ))}
                    </ul>

                    {works.length > 1 && <Paging data={works} page={page} setPage={setPage} />}
                </section>
            }
        </div>
    )
}

export default Works;